const creditsUrl = '/credits';

export default creditsUrl;
